import { Component, OnInit } from '@angular/core';
import { MatSnackBarComponent } from '../mat-snack-bar/mat-snack-bar.component';
import { ProductList } from 'src/app/Models/Admin/ProductConfiguration';
import { ProductConfigurationService } from 'src/app/Services/admin-rights/product-configuration.service';
import { Router } from '@angular/router';
import { ToastrModule, ToastrService } from 'ngx-toastr';

@Component({
  selector : 'app-product-configuration',
  templateUrl : './product-configuration.component.html',
  styleUrls : ['./product-configuration.component.css']
})
export class ProductConfigurationComponent implements OnInit {
  productList : any[];
  loader : string = 'none';

  constructor(private snackBar: MatSnackBarComponent, private productConfigurationService : ProductConfigurationService, private router: Router,private toastr: ToastrService) { }

  ngOnInit() {
    if (sessionStorage.tabID == undefined) {
      this.router.navigate(['/MCMaterial/Login']);
    }
    this.getProductList();
  }
  getProductList(){
    this.loader = 'block';
    this.productConfigurationService.getProductList()
    .subscribe((resdata : any) =>{
      if(resdata.status == true){
        this.productList = resdata.data;
        this.loader = 'none';
      }
      else
      {
        this.toastr.error(resdata.msg);
        this.loader = 'none';
      }
    })
  }

  UpdateProductVisibility(){
    this.loader = 'block';
    let brandList : ProductList[] = [];
    this.productList.forEach(function (detail) {
      var approvedQty = {
        BrandName : detail.brandName,
        IsActive : detail.active
        };
        brandList.push(approvedQty)
    });
    this.productConfigurationService.updateProductConfiguration(brandList)
      .subscribe((resdata : any) => {
        if (resdata.status == true) {
          this.toastr.success('Product List have been Configured.');
            this.loader = 'none';
            this.getProductList();
        }
        else {
          this.toastr.error(resdata.msg);
          this.loader = 'none';
        }
      });
  }
}
